import * as React from "react"

import {navWidth} from "../../@signals";
import BaseDesktopDrawer from "./@BaseDrawer";


export default function AppExtendedNavDrawer({ children, ...props }) {
    return <BaseDesktopDrawer {...props} PaperProps={{
        ...props?.PaperProps,
        sx: {
            width: navWidth.value,
            ...props?.PaperProps?.sx,
        }
    }}>
        {children}
    </BaseDesktopDrawer>
}